import { render, staticRenderFns } from "./newStore.vue?vue&type=template&id=6c7f6826"
import script from "./newStore.vue?vue&type=script&lang=js"
export * from "./newStore.vue?vue&type=script&lang=js"
import style0 from "./newStore.vue?vue&type=style&index=0&id=6c7f6826&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports